<div class="auth-fullpage">
  <div id="logo-container">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>
  <div id="message">
    {{ 'AUTH_TIMEOUT' | translate }}
  </div>
</div>
